














import Vue from 'vue'
import Component from 'vue-class-component'
import SidebarMenuItem from './menuItem/SidebarMenuItem.vue'
import SidebarMenuActionItem from './menuItem/SidebarMenuActionItem.vue'
import { StoreActionTypes } from '@/store/types'
import { IconDefinition, faTasks, faBuilding, faQrcode, faWindowRestore, faSignOutAlt, faChartLine } from '@fortawesome/free-solid-svg-icons'

@Component({
    components: {
        SidebarMenuItem,
        SidebarMenuActionItem
    }
})
export default class SidebarNav extends Vue {
    private componentclass = "SidebarNav"

    private criteriaIcon: IconDefinition = faTasks
    private companiesIcon: IconDefinition = faBuilding
    private licensesIcon: IconDefinition = faQrcode
    private categoriesIcon: IconDefinition = faWindowRestore
    private exitIcon: IconDefinition = faSignOutAlt
    private dashboardIcon: IconDefinition  = faChartLine

    handleLogout() {
        this.$store.dispatch(StoreActionTypes.LOG_OUT)
        this.$router.push('login')
    }
}
